import React from 'react'
import ChartistGraph from 'react-chartist'
import People from '@material-ui/icons/People'
import Business from '@material-ui/icons/Business'
import School from '@material-ui/icons/School'
import DateRange from '@material-ui/icons/DateRange'
import AccessTime from '@material-ui/icons/AccessTime'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'

import {
  getDashboardStats,
  monthlyCoursesChart,
  dailyAttendeesChart,
  topProviderTable
} from './helpers/stats'
import arrayToCsv from 'helpers/file/array-to-csv'

import { StatsCard, ChartCard, RegularCard, Table, ItemGrid } from 'components'

import dashboardStyle from 'assets/jss/dashboard/dashboardStyle'

const Dashboard = props => {
  const {
    attendeeList,
    monthStats,
    totalStats,
    weekStats,
    providerStats
  } = getDashboardStats(props)
  const monthlyCoursesData = monthlyCoursesChart(monthStats)
  const dailyAttendeesData = dailyAttendeesChart(weekStats)
  const topProviderData = topProviderTable(providerStats)

  const { courses, providers } = props

  return (
    <React.Fragment>
      <Grid container>
        <ItemGrid xs={12} sm={6} md={3}>
          <StatsCard
            icon={School}
            iconColor="orange"
            title="Courses Recorded"
            description={totalStats.coursesRecorded}
            statIcon={DateRange}
            statText="Year to Date"
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6} md={3}>
          <StatsCard
            icon={People}
            iconColor="green"
            title="Total Attendees"
            description={totalStats.attendees}
            statIcon={DateRange}
            statLink={{
              text: 'Year to Date',
              href: '#',
              onClick: () => arrayToCsv(attendeeList)
            }}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6} md={3}>
          <StatsCard
            icon={Business}
            iconColor="red"
            title="Providers Serviced"
            description={totalStats.providers}
            statIcon={DateRange}
            statText="This Year"
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6} md={3}>
          <StatsCard
            icon={DateRange}
            iconColor="blue"
            title="Courses Booked"
            description={totalStats.courses}
            statIcon={DateRange}
            statLink={{
              text: 'This Year',
              href: '#',
              onClick: () =>
                arrayToCsv(
                  Object.values(courses).map(({ attendees, ...c }) => ({
                    ...c,
                    archive: Boolean(c.archived),
                    cancelled: Boolean(c.cancelled),
                    provider: providers[c.provider].name
                  }))
                )
            }}
          />
        </ItemGrid>
      </Grid>
      <Grid container>
        <ItemGrid xs={12} sm={12} md={6}>
          <ChartCard
            chart={
              <ChartistGraph
                className="ct-chart"
                data={dailyAttendeesData.data}
                type="Line"
                options={dailyAttendeesData.options}
                listener={dailyAttendeesData.animation}
              />
            }
            chartColor="green"
            title="Daily Attendees"
            text="Total attendees each day for the last week"
            statIcon={AccessTime}
            statText="Last 7 Days"
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={6}>
          <ChartCard
            chart={
              <ChartistGraph
                className="ct-chart"
                data={monthlyCoursesData.data}
                type="Bar"
                options={monthlyCoursesData.options}
                responsiveOptions={monthlyCoursesData.responsiveOptions}
                listener={monthlyCoursesData.animation}
              />
            }
            chartColor="orange"
            title="Course Bookings"
            text="Total courses booked by calendar month"
            statIcon={DateRange}
            statText="This Year"
          />
        </ItemGrid>
      </Grid>
      <Grid container>
        <ItemGrid xs={12} sm={12} md={12}>
          <RegularCard
            headerColor="red"
            cardTitle="Provider Stats"
            cardSubtitle={`Top 5 providers for ${new Date().getFullYear()}`}
            content={
              <Table
                tableHeaderColor="warning"
                tableHead={topProviderData.columns}
                tableData={topProviderData.rows}
              />
            }
          />
        </ItemGrid>
      </Grid>
    </React.Fragment>
  )
}

export default withStyles(dashboardStyle)(Dashboard)



// WEBPACK FOOTER //
// ./src/views/Dashboard/Main/Dashboard.jsx